var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    {
      staticClass: "site-main-container",
      class: { expanded: _vm.collapse },
      style: {
        marginTop: !_vm.isFullScreen && !_vm.isConfigMode ? "-75px" : "",
      },
      attrs: { fluid: "", "align-center": "" },
    },
    [
      !_vm.isConfigMode
        ? _c(
            "div",
            {
              staticClass: "btn-mobile",
              staticStyle: {
                position: "absolute",
                top: "15px",
                right: "15px",
                width: "100%",
                "z-index": "1000",
                "pointer-events": "none",
              },
            },
            [
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0",
                    "font-size": "16px",
                    color: "#666",
                    "text-align": "right",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.Prezzo_di_listino")) + ": "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color: "black",
                      },
                    },
                    [_vm._v("219€")]
                  ),
                ]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0",
                    "margin-top": "-5px",
                    "font-weight": "bold",
                    "text-align": "right",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "400",
                        color: "#666",
                      },
                    },
                    [
                      _vm._v(
                        "(+20€ " +
                          _vm._s(
                            _vm.$t("message.Incisione").toString().toLowerCase()
                          ) +
                          ")"
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      !_vm.activeModelFromQrCode
        ? _c(
            "div",
            {
              staticClass: "alertQrCode",
              staticStyle: { position: "absolute", "z-index": "1000" },
            },
            [
              _c("div", { staticClass: "alert-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        return _vm.closeAlertQrcode()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          fill: "#ff0000",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "m18.75 6.82-1.57-1.57L12 10.43 6.82 5.25 5.25 6.82 10.43 12l-5.18 5.18 1.57 1.57L12 13.57l5.18 5.18 1.57-1.57L13.57 12l5.18-5.18Z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "text uppercase" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("message.configurazione_non_valida"))),
                  ]),
                  _c("p", { staticClass: "uppercase" }, [
                    _vm._v(" " + _vm._s(_vm.activeModelText) + " "),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isConfigMode
        ? _c(
            "v-layout",
            {
              style: { marginTop: !_vm.isConfigMode ? "10vh" : "" },
              attrs: { id: "user-menu" },
            },
            [
              _vm.config.btn_ritornaHome
                ? _c("v-flex", {
                    staticClass: "button-return d-none d-sm-flex left-home",
                    attrs: { xs4: "" },
                  })
                : _c("v-flex", { attrs: { xs4: "" } }),
              _vm.isConfigMode
                ? _c(
                    "v-flex",
                    { staticClass: "site-logo", attrs: { xs4: "", md4: "" } },
                    [_c("img", { attrs: { src: _vm.logoImage, alt: "Logo" } })]
                  )
                : _vm._e(),
              _vm.$vuetify.breakpoint.smAndDown
                ? _c("v-flex", { attrs: { md2: "" } })
                : _vm._e(),
              _vm.$vuetify.breakpoint.mdAndUp && _vm.isConfigMode
                ? _c(
                    "v-flex",
                    {
                      staticClass: "profile-section right-home",
                      attrs: { xs4: "", md3: "", "mt-3": "" },
                    },
                    [
                      _vm.isConfigMode
                        ? _c("HistoryButton", {
                            attrs: { userIsGuest: _vm.userIsGuest },
                          })
                        : _vm._e(),
                      _vm.isConfigMode
                        ? _c("User", {
                            attrs: {
                              darkTheme: _vm.darkTheme,
                              configurations: _vm.configurations,
                              currentTab: _vm.currentTab,
                              haveConfigurations: _vm.haveConfigurations,
                            },
                          })
                        : _vm._e(),
                      _c("LanguageButton", {
                        nativeOn: {
                          click: function ($event) {
                            _vm.openLanguageSelection = true
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm.isConfigMode
                ? _c(
                    "v-flex",
                    {
                      staticClass:
                        "d-flex flex-column align-center menu-container",
                      class: {
                        "menu-opened": _vm.isMenuOpen,
                        dark: _vm.darkTheme,
                      },
                      attrs: { xs2: "", shrink: "" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { large: "", fab: "", icon: "", plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.isMenuOpen = !_vm.isMenuOpen
                            },
                          },
                        },
                        [
                          _c(
                            "v-fade-transition",
                            { attrs: { name: "fade", mode: "out-in" } },
                            [
                              !_vm.isMenuOpen
                                ? _c(
                                    "v-icon",
                                    {
                                      key: "i-1",
                                      attrs: {
                                        large: "",
                                        fab: "",
                                        color: "primary",
                                      },
                                    },
                                    [_vm._v("menu")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      key: "i-2",
                                      attrs: {
                                        large: "",
                                        fab: "",
                                        color: "primary",
                                      },
                                    },
                                    [_vm._v("close")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expand-transition",
                        [
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isMenuOpen,
                                  expression: "isMenuOpen",
                                },
                              ],
                              staticClass: "flex-column pb-5",
                              staticStyle: { display: "none", gap: "0.7rem" },
                            },
                            [
                              _c("User", {
                                attrs: {
                                  darkTheme: _vm.darkTheme,
                                  configurations: _vm.configurations,
                                  currentTab: _vm.currentTab,
                                  haveConfigurations: _vm.haveConfigurations,
                                },
                              }),
                              _c("ShowCartButton", {
                                attrs: {
                                  canShowCart: _vm.canShowCart,
                                  cartTotal: _vm.cartTotal,
                                },
                              }),
                              _c("FavoriteButton", {
                                attrs: {
                                  canAddToCart: _vm.canAddToCart,
                                  isConfigurationSaved:
                                    _vm.isConfigurationSaved,
                                },
                                on: {
                                  added: function ($event) {
                                    _vm.goToFavs = true
                                  },
                                },
                              }),
                              _c("HistoryButton", {
                                attrs: { userIsGuest: _vm.userIsGuest },
                              }),
                              _c("PrintButton"),
                              _c("LanguageButton", {
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.openLanguageSelection = true
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-layout",
        {
          staticClass: "multi-warning",
          attrs: { "justify-end": "", id: "multistrato-instruction" },
        },
        [
          _vm.$store.state.configurator.colore &&
          _vm.$store.state.configurator.colore.Category == "MULTISTRATO"
            ? _c(
                "v-flex",
                { attrs: { xs6: "", md3: "" } },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "anteprima-alert",
                      attrs: {
                        value:
                          _vm.$store.state.configurator.colore &&
                          _vm.$store.state.configurator.colore.Category ==
                            "MULTISTRATO",
                        type: "warning",
                      },
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.frontColor) +
                            " " +
                            _vm._s(
                              _vm.$t("message.Anteprima_non_disponibile")
                            ) +
                            "! "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "v-container",
                    { staticClass: "instructions" },
                    [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$t("message.Colore_esterno"))),
                      ]),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs4: "" } }, [
                            _c("img", {
                              staticClass: "color-prev",
                              attrs: {
                                src: _vm.colore && _vm.colore.imageUrl,
                                width: "100%",
                              },
                            }),
                          ]),
                          _c("v-flex", { attrs: { xs8: "" } }, [
                            _c("img", {
                              staticClass: "mini-preview",
                              attrs: {
                                src: require("../assets/help/no_prev_outside.svg"),
                                width: "100%",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$t("message.Colore_interno"))),
                      ]),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs4: "" } }, [
                            _c("img", {
                              staticClass: "color-prev",
                              attrs: {
                                src: _vm.colore && _vm.colore.backImageUrl,
                                width: "100%",
                              },
                            }),
                          ]),
                          _c("v-flex", { attrs: { xs8: "" } }, [
                            _c("img", {
                              staticClass: "mini-preview",
                              attrs: {
                                src: require("../assets/help/no_prev_inside.svg"),
                                width: "100%",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-slide-x-reverse-transition",
        [
          _vm.openLanguageSelection
            ? _c("LanguageCard", {
                attrs: { right: "" },
                on: {
                  "close-menu-language": function ($event) {
                    _vm.openLanguageSelection = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          staticClass: "go-to-favs",
          attrs: { top: "", absolute: "", color: "primary" },
          model: {
            value: _vm.goToFavs,
            callback: function ($$v) {
              _vm.goToFavs = $$v
            },
            expression: "goToFavs",
          },
        },
        [
          _vm._v(" Your Design was saved to Favorites. "),
          _c(
            "v-btn",
            {
              attrs: { text: "" },
              on: {
                click: function ($event) {
                  ;(_vm.profileOpen = true), (_vm.currentTab = "tab-favorites")
                },
              },
            },
            [
              _vm._v(" Go to Favorites "),
              _c("v-icon", { staticStyle: { "margin-left": "5px" } }, [
                _vm._v("arrow_forward"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("Canvas3d", {
        staticClass: "canvas-3d",
        attrs: {
          shouldLoadScene: false,
          defaultFrontModel: _vm.defaultFrontModel,
          defaultFrontColor: _vm.defaultFrontColor,
          defaultTemplesColor: _vm.defaultTemplesColor,
        },
      }),
      _c(
        "div",
        { attrs: { id: "stepper-wrap" } },
        [
          _c(
            "v-layout",
            {
              staticClass: "attached-elements",
              attrs: { "justify-center": "", "align-center": "" },
            },
            [
              _vm.isConfigMode
                ? _c("v-flex", { attrs: { xs4: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-center d-none d-sm-flex d-lg-none",
                      },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "buttons-bottom d-flex" },
                          [
                            _vm.config.button_storeLocator
                              ? _c("StoreLocatorButton")
                              : _vm._e(),
                            _c("ShowCartButton", {
                              attrs: {
                                canShowCart: _vm.canShowCart,
                                cartTotal: _vm.cartTotal,
                              },
                            }),
                            _vm.config.button_favorite
                              ? _c("FavoriteButton", {
                                  attrs: {
                                    canAddToCart: _vm.canAddToCart,
                                    isConfigurationSaved:
                                      _vm.isConfigurationSaved,
                                  },
                                  on: {
                                    added: function ($event) {
                                      _vm.goToFavs = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.config.button_print
                              ? _c("PrintButton")
                              : _vm._e(),
                            _vm.config.button_share
                              ? _c("ShareButton")
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("v-flex", { attrs: { xs4: "" } }),
              _c(
                "v-flex",
                { staticClass: "collapse-arrow ma-2", attrs: { xs4: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      class: { rotate180deg: _vm.collapse },
                      attrs: { "x-large": "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.collapse = !_vm.collapse
                        },
                      },
                    },
                    [_vm._v("keyboard_arrow_down")]
                  ),
                ],
                1
              ),
              _c("v-flex", { staticClass: "cart-mobile", attrs: { xs4: "" } }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "add-cart-button d-flex justify-center align-center d-lg-none",
                    staticStyle: { width: "48px", height: "48px" },
                    style: {
                      backgroundColor: _vm.canAddToCart ? "black" : "grey",
                      borderRadius: "100%",
                    },
                    attrs: { disabled: !_vm.canAddToCart },
                    on: {
                      click: function ($event) {
                        return _vm.startAddToCart()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        class: { disabled: !_vm.canAddToCart },
                        staticStyle: {
                          "margin-top": "1px",
                          "margin-left": "-2px",
                        },
                        attrs: {
                          width: "22",
                          height: "22",
                          fill: "none",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg",
                          stroke: _vm.canAddToCart ? "white" : "white",
                        },
                      },
                      [
                        _c("path", {
                          attrs: { d: "M9 20a1 1 0 1 0 0 2 1 1 0 1 0 0-2z" },
                        }),
                        _c("path", {
                          attrs: { d: "M20 20a1 1 0 1 0 0 2 1 1 0 1 0 0-2z" },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "v-stepper",
            {
              staticClass: "stepper",
              staticStyle: { overflow: "visible" },
              attrs: { "non-linear": "" },
              model: {
                value: _vm.e1,
                callback: function ($$v) {
                  _vm.e1 = $$v
                },
                expression: "e1",
              },
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "align-center select-menu",
                  class: { dark: _vm.darkTheme },
                  staticStyle: {
                    overflow: "auto",
                    "scroll-behavior": "smooth",
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "container-dark-mode align-center justify-center d-none d-sm-none d-lg-flex",
                      attrs: { xs: "0", lg: "3" },
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.$vuetify.breakpoint.mdAndUp
                            ? _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "buttons-bottom d-none d-sm-none d-lg-flex",
                                },
                                [
                                  _vm.config.button_storeLocator &&
                                  _vm.isConfigMode
                                    ? _c("StoreLocatorButton")
                                    : _vm._e(),
                                  _vm.isConfigMode
                                    ? _c("ShowCartButton", {
                                        attrs: {
                                          canShowCart: _vm.canShowCart,
                                          cartTotal: _vm.cartTotal,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.config.button_favorite && _vm.isConfigMode
                                    ? _c("FavoriteButton", {
                                        attrs: {
                                          canAddToCart: _vm.canAddToCart,
                                          isConfigurationSaved:
                                            _vm.isConfigurationSaved,
                                        },
                                        on: {
                                          added: function ($event) {
                                            _vm.goToFavs = true
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.config.button_print && _vm.isConfigMode
                                    ? _c("PrintButton")
                                    : _vm._e(),
                                  _c("ResetButton", {
                                    attrs: {
                                      defaultFrontModel: _vm.defaultFrontModel,
                                      defaultFrontColor: _vm.defaultFrontColor,
                                      defaultTemplesColor:
                                        _vm.defaultTemplesColor,
                                    },
                                    on: {
                                      "reset-configuration":
                                        _vm.resetConfiguration,
                                    },
                                  }),
                                  _vm.config.button_share && _vm.isConfigMode
                                    ? _c("ShareButton")
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "step-container d-flex align-center",
                      attrs: { xs: "12", lg: "6" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "step-header" },
                        [
                          _c(
                            "v-stepper-step",
                            {
                              ref: "stepperOne",
                              staticClass: "step",
                              class: _vm.validateFrontali
                                ? ""
                                : "stepper-error",
                              staticStyle: { "z-index": "100" },
                              attrs: {
                                complete: _vm.validateFrontali,
                                step: "1",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$refs.stepperTwo.$el.scrollIntoView(
                                    true,
                                    {
                                      behavior: "smooth",
                                    }
                                  )
                                  _vm.openBottomTab()
                                  _vm.e1 = 1
                                },
                              },
                            },
                            [
                              _c("h3", { staticStyle: { display: "block" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.frontali").toUpperCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c("div", {
                            staticClass: "triangle",
                            staticStyle: { "z-index": "100" },
                          }),
                          _c(
                            "v-stepper-step",
                            {
                              ref: "stepperTwo",
                              staticClass: "step",
                              staticStyle: { "z-index": "98" },
                              attrs: {
                                complete: _vm.validateColori,
                                step: "2",
                                ripple: false,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$refs.stepperThree.$el.scrollIntoView(
                                    true,
                                    {
                                      behavior: "smooth",
                                    }
                                  )
                                  _vm.openBottomTab()
                                  _vm.e1 = 2
                                },
                              },
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.colori").toUpperCase())
                                ),
                              ]),
                            ]
                          ),
                          !_vm.btActive
                            ? _c("div", {
                                staticClass: "triangle",
                                staticStyle: { "z-index": "100" },
                              })
                            : _vm._e(),
                          _c(
                            "v-stepper-step",
                            {
                              ref: "stepperThree",
                              staticClass: "step",
                              staticStyle: { "z-index": "96" },
                              style: {
                                display: _vm.btActive ? "none" : "flex",
                              },
                              attrs: {
                                complete: _vm.validateAste,
                                step: "3",
                                ripple: false,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$refs.stepperFour.$el.scrollIntoView(
                                    true,
                                    {
                                      behavior: "smooth",
                                    }
                                  )
                                  _vm.openBottomTab()
                                  _vm.e1 = 3
                                },
                              },
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.Aste").toUpperCase())
                                ),
                              ]),
                            ]
                          ),
                          !_vm.btActive
                            ? _c("div", {
                                staticClass: "triangle",
                                staticStyle: { "z-index": "100" },
                              })
                            : _vm._e(),
                          !_vm.btActive
                            ? _c(
                                "v-stepper-step",
                                {
                                  ref: "stepperFour",
                                  staticClass: "step",
                                  staticStyle: { "z-index": "92" },
                                  attrs: {
                                    complete: _vm.validateNome,
                                    step: 4,
                                    ripple: false,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.glassType == "S"
                                        ? _vm.$refs.stepperFive.$el.scrollIntoView(
                                            true,
                                            {
                                              behavior: "smooth",
                                            }
                                          )
                                        : _vm.$refs.addToCart.$el.scrollIntoView(
                                            true,
                                            {
                                              behavior: "smooth",
                                            }
                                          )
                                      _vm.openBottomTab()
                                      _vm.e1 = 4
                                    },
                                  },
                                },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.Nome").toUpperCase()
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.glassType == "S"
                            ? _c("div", {
                                staticClass: "triangle",
                                staticStyle: { "z-index": "100" },
                              })
                            : _vm._e(),
                          _vm.glassType == "S"
                            ? _c(
                                "v-stepper-step",
                                {
                                  ref: "stepperFive",
                                  staticClass: "step",
                                  staticStyle: { "z-index": "90" },
                                  attrs: {
                                    complete: _vm.validateLenti,
                                    step: 5,
                                    ripple: false,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.addToCart.$el.scrollIntoView(
                                        true,
                                        {
                                          behavior: "smooth",
                                        }
                                      )
                                      _vm.openBottomTab()
                                      _vm.e1 = 5
                                    },
                                  },
                                },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.Lenti").toUpperCase()
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-none d-lg-flex pr-4",
                      staticStyle: { "justify-content": "flex-end" },
                      attrs: {
                        xs: "0",
                        lg: "3",
                        grow: "",
                        "justify-end": "",
                        "align-center": "",
                      },
                    },
                    [
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            "max-width": "500px",
                            transition: "dialog-transition",
                          },
                          model: {
                            value: _vm.rowNotesDialog,
                            callback: function ($$v) {
                              _vm.rowNotesDialog = $$v
                            },
                            expression: "rowNotesDialog",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "login-window",
                              attrs: { shaped: "", elevation: "5" },
                            },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "align-center bg-primary" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "ml-3 my-0 mr-0 p-0" },
                                    [_vm._v(_vm._s(_vm.$t("message.Note")))]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", color: "white" },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.rowNotesDialog = false
                                          _vm.note = ""
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          !_vm.isConfigMode
                            ? _c("div", { staticClass: "btn-desktop" }, [
                                _c("p", { staticClass: "price-line" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.Prezzo_di_listino")
                                    ) + ": "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "20px",
                                        "font-weight": "bolder",
                                        color: "black",
                                      },
                                    },
                                    [_vm._v("219€")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "600",
                                        color: "#666",
                                        "margin-left": "6px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "(+20€ " +
                                          _vm._s(
                                            _vm
                                              .$t("message.Incisione")
                                              .toString()
                                              .toLowerCase()
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              ref: "addToCart",
                              staticClass: "pa-6",
                              staticStyle: { width: "100%" },
                              attrs: {
                                color: "primary",
                                disabled: !_vm.canAddToCart,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.startAddToCart()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.Aggiungi_al_carrello"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-stepper-items",
                {
                  staticClass: "stepper-items",
                  class: { collapsed: _vm.collapse },
                },
                [
                  _c(
                    "v-stepper-content",
                    { staticClass: "step-content", attrs: { step: "1" } },
                    [
                      _c("Frontali", {
                        attrs: {
                          darkTheme: _vm.darkTheme,
                          isOpen: _vm.frontali.active,
                          revealSetting: _vm.frontali.settingItem,
                          stepperChange: _vm.stepperChange,
                        },
                        on: {
                          "reset-configuration": _vm.resetConfiguration,
                          "reset-setting-item": _vm.resetSettingItem,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-content",
                    { staticClass: "step-content", attrs: { step: "2" } },
                    [
                      _c("ColoriFrontali", {
                        attrs: {
                          darkTheme: _vm.darkTheme,
                          isOpen: _vm.colori.active,
                          revealSetting: _vm.colori.settingItem,
                        },
                        on: { "reset-setting-item": _vm.resetSettingItem },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-content",
                    { staticClass: "step-content", attrs: { step: "3" } },
                    [
                      _c("Aste", {
                        attrs: {
                          darkTheme: _vm.darkTheme,
                          isOpen: _vm.aste.active,
                          revealSetting: _vm.aste.settingItem,
                        },
                        on: { "reset-setting-item": _vm.resetSettingItem },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-content",
                    { staticClass: "step-content", attrs: { step: 4 } },
                    [
                      _c("Nome", {
                        attrs: {
                          darkTheme: _vm.darkTheme,
                          isOpen: _vm.nome.active,
                        },
                        on: { "reset-setting-item": _vm.resetSettingItem },
                      }),
                    ],
                    1
                  ),
                  _vm.glassType == "S"
                    ? _c(
                        "v-stepper-content",
                        { staticClass: "step-content", attrs: { step: 5 } },
                        [
                          _c("LentiSole", {
                            attrs: {
                              darkTheme: _vm.darkTheme,
                              isOpen: _vm.nome.active,
                            },
                            on: { "reset-setting-item": _vm.resetSettingItem },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }